import { render, staticRenderFns } from "./UserLocalisationsTable.vue?vue&type=template&id=31724e6a"
import script from "./UserLocalisationsTable.vue?vue&type=script&lang=js"
export * from "./UserLocalisationsTable.vue?vue&type=script&lang=js"
import style0 from "./UserLocalisationsTable.vue?vue&type=style&index=0&id=31724e6a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports